export default {
  apiVersion: 2,
  development: {
    accessToken: '6c2121047cafc6899537688dc2d6e645',
    url: 'http://spretturinn.dev.moya.is/_/moya/pilot/api',
  },
  production: {
    accessToken: '6c2121047cafc6899537688dc2d6e645',
    url: 'https://api.spretturinn.is/_/moya/pilot/api',
  },
};
